
import BaseStore from "jimbo/store";

import { promotionPackageClassFactory } from "schema/promotions";

export default class PromotionsStore extends BaseStore {


    constructor({rootStore, baseApi}) {
        super({rootStore, baseApi});
    }

    fromJsonToObject = (initialData) => {
        const notification =  promotionPackageClassFactory.createInstance("Promotion", {initialData});
        return notification;
    }

    doCreateNewObject =  ({initValues}) => {
        return promotionPackageClassFactory.createInstance("Promotion", {});
    }

}